// Environment configuration using Vite environment variables
// All variables should be defined in .env file with VITE_ prefix

export const ENV = {
  // Firebase Configuration
  FIREBASE: {
    API_KEY: import.meta.env.VITE_FIREBASE_API_KEY || '',
    AUTH_DOMAIN: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || '',
    PROJECT_ID: import.meta.env.VITE_FIREBASE_PROJECT_ID || '',
    STORAGE_BUCKET: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || '',
    MESSAGING_SENDER_ID: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '',
    APP_ID: import.meta.env.VITE_FIREBASE_APP_ID || '',
  },

  // API Configuration
  API: {
    BASE_URL: import.meta.env.VITE_API_BASE_URL!,
    TIMEOUT: Number(import.meta.env.VITE_API_TIMEOUT) || 10000,
  },

  // App Configuration
  APP: {
    NAME: import.meta.env.VITE_APP_NAME || 'Service Strike',
    VERSION: __APP_VERSION__,
  },

  // Google Maps Configuration
  GOOGLE_MAPS: {
    API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
  },

  // Location Tracking Configuration
  LOCATION: {
    // Interval between location updates while moving, in milliseconds (default 5 minutes)
    UPDATE_INTERVAL_MS: Number(import.meta.env.VITE_LOCATION_UPDATE_INTERVAL_MS) || 300000,
    // Heartbeat interval in seconds - fires when stationary to ensure updates (default 4 minutes)
    HEARTBEAT_INTERVAL_SEC: Number(import.meta.env.VITE_LOCATION_HEARTBEAT_INTERVAL_SEC) || 240,
  },

  // Background Geolocation License (leave empty for debug mode)
  BG_GEO_LICENSE_KEY: import.meta.env.VITE_BG_GEO_LICENSE_KEY || '',

  // Development flags
  IS_DEVELOPMENT: import.meta.env.DEV,
  IS_PRODUCTION: import.meta.env.PROD,

  // Payment Configuration
  STRIPE_PUBLISHABLE_KEY: import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '',
};

